/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Company } from './Company';
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
} from './Company';
import type { Target } from './Target';
import { TargetFromJSON, TargetFromJSONTyped, TargetToJSON } from './Target';

/**
 *
 * @export
 * @interface LoginSchema
 */
export interface LoginSchema {
  /**
   *
   * @type {Company}
   * @memberof LoginSchema
   */
  company: Company;
  /**
   *
   * @type {any | null}
   * @memberof LoginSchema
   */
  config: any | null;
  /**
   *
   * @type {Target}
   * @memberof LoginSchema
   */
  user: Target;
}

/**
 * Check if a given object implements the LoginSchema interface.
 */
export function instanceOfLoginSchema(value: object): value is LoginSchema {
  if (!('company' in value) || value['company'] === undefined) return false;
  if (!('config' in value) || value['config'] === undefined) return false;
  if (!('user' in value) || value['user'] === undefined) return false;
  return true;
}

export function LoginSchemaFromJSON(json: any): LoginSchema {
  return LoginSchemaFromJSONTyped(json, false);
}

export function LoginSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LoginSchema {
  if (json == null) {
    return json;
  }
  return {
    company: CompanyFromJSON(json['company']),
    config: json['config'],
    user: TargetFromJSON(json['user']),
  };
}

export function LoginSchemaToJSON(value?: LoginSchema | null): any {
  if (value == null) {
    return value;
  }
  return {
    company: CompanyToJSON(value['company']),
    config: value['config'],
    user: TargetToJSON(value['user']),
  };
}
